import { Form, Select } from 'antd';
import React from 'react';
import { emailValidator } from '../../utils/DataAccessUtils';

export default function MultiEmailComponentAntdV4({ fieldProps, ...props }) {
	return (
		<Form.Item
			{...fieldProps}
			rules={[...(fieldProps.rules || []), { validator: emailValidator }]}
			normalize={(e) => {
				const filteredArray = e.map((item, index) => {
					if (!item.match(/^(.+)@(.+)$/)) {
						return undefined;
					}

					return item.replace(/[<>]/g, '');
				});
				return filteredArray.filter((item) => item);
			}}
		>
			<Select
				tokenSeparators={[',', ' ', ';', ':']}
				optionFilterProp="label"
				placeholder="Enter emails"
				mode="tags"
				open={false}
				allowClear
				{...props}
			/>
		</Form.Item>
	);
}
